import { Injectable } from '@angular/core';
import { PinnedTable } from '@mode/shared/contract-common';
import { AnalyticsService } from '@mode/shared/util-segment';
import { ToastService } from '@mode/shared/util-toast';
import { Store } from '@ngrx/store';
import { differenceInMinutes } from 'date-fns';
import { BehaviorSubject, map } from 'rxjs';
import * as SchemaBrowserActions from './browser.actions';

@Injectable({ providedIn: 'root' })
export class SchemaBrowserFacade {
  private pinnedTablesSubject = new BehaviorSubject<PinnedTable[]>([]);

  public pinnedTables$ = this.pinnedTablesSubject
    .asObservable()
    .pipe(map((pins) => pins.map((pin) => `${pin.schema}.${pin.name}`)));

  constructor(
    private store: Store,
    private analyticsService: AnalyticsService,
    private toastService: ToastService
  ) {}

  public setPins(pins: PinnedTable[]): void {
    this.pinnedTablesSubject.next(pins);
  }

  public getPins(): PinnedTable[] {
    return this.pinnedTablesSubject.value;
  }

  public notifyUserAboutError(dataSourceCreatedAt: Date): void {
    if (differenceInMinutes(new Date(), dataSourceCreatedAt) < 2) {
      this.toastService.info(`Schema update in progress`);
    } else {
      this.toastService.error('Unable to load more schemas. Please try again.');
    }
  }

  public showMoreSchemasClicked(reportToken: string): void {
    this.store.dispatch(
      SchemaBrowserActions.showMoreSchemasClicked({
        context: this.analyticsService.context,
        buttonClicked: 'show more schemas',
        reportToken,
      })
    );
  }

  public showMoreTablesClicked(reportToken: string): void {
    this.store.dispatch(
      SchemaBrowserActions.showMoreTablesClicked({
        context: this.analyticsService.context,
        buttonClicked: 'show more tables',
        reportToken,
      })
    );
  }
}
